// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
};

// ----------------------------------------------------------------------

export const paths = {
  public: {
    root: '/',
    caseStudies: {
      portfolio: '/portfolio',
      focus: '/portfolio/focus',
      loha: '/portfolio/loha',
    },
    buildex: '/portfolio/buildex',
    caseStudy: (id = ':id') => `/portfolio/${id}`,
    work: (id = ':id') => `/work/${id}`,
    schedule: '/schedule',
    eCommerce: '/eCommerce/GCC',
    services: {
      website: '/services/website',
      software: '/services/software',
      mobileApp: '/services/mobileApp',
    },

  },
  // AUTH
  auth: {
    // login: `${ROOTS.AUTH}/login/admin`,
  },
};
